import { useDraggable } from '@dnd-kit/core';
import { EventBlock } from './EventBlock';
import type { Event } from '@/hooks/useEvents';

interface DraggableEventBlockProps {
  event: Event;
  top: number;
  height: number;
  width?: number;
  left?: number;
  onClick: (event: Event) => void;
  viewType: "day" | "3day" | "week";
}

export function DraggableEventBlock(props: DraggableEventBlockProps) {
  const { event } = props;
  
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: event.id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragging ? 'grabbing' : 'grab',
      }
    : { cursor: 'grab' };

  return (
    <div ref={setNodeRef} {...listeners} {...attributes} style={style}>
      <EventBlock {...props} />
    </div>
  );
}
